import React, { useEffect } from 'react';
import Modal from 'react-modal';
import { observer } from 'mobx-react';
import { Box, TextField } from '@material-ui/core';
import { useStores } from '../../hooks/use-stores';
import { CloseBtn, Title } from '../UI/Modal';
import PreloadButton from '../../interface/PreloadButton';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useHistory } from 'react-router-dom';

const DeliveryModal = observer(({ open, onClose }) => {
    const history = useHistory();
    const { CartStore: store } = useStores();

    useEffect(() => {
        store.getDeliveryMethods();
    }, [store]);

    // Handlers
    const handleSubmit = e => {
        e.preventDefault();

        store.sendOrder(history, onClose);
    };

    // Render
    return (
        <Modal
            isOpen={open}
            onClose={onClose}
            onRequestClose={onClose}
            className="Modal order-modal"
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEsc={false}
            ariaHideApp={false}
        >
            <CloseBtn onClose={onClose} />
            <Box mb={6}>
                <Title align="center">Доставка</Title>
            </Box>

            <form onSubmit={handleSubmit}>
                <Box mb={4}>
                    <Autocomplete
                        popupIcon={<ExpandMoreIcon />}
                        options={store.deliveryMethods}
                        loading={store.deliveryMethodsLoading}
                        getOptionLabel={type => type.name}
                        value={store.delivery.type}
                        onChange={(e, value) => store.handleDeliveryChange('type', value)}
                        renderInput={params => <TextField {...params} fullWidth label="Тип доставки" required />}
                        noOptionsText="Нет данных"
                        loadingText="Загрузка..."
                        disabled={store.deliveryMethodsLoading}
                    />
                </Box>

                <Box mb={8}>
                    <TextField
                        value={store.delivery.address}
                        onChange={e => store.handleDeliveryChange('address', e.target.value)}
                        label="Адрес"
                        helperText="Если у вас разные объекты, укажите в поле «Разные регионы»"
                        disabled={store.loading}
                        fullWidth
                        required
                    />
                </Box>

                <PreloadButton isLoad={store.loading}>Отправить заявку</PreloadButton>
            </form>
        </Modal>
    );
});

export default DeliveryModal;
